import { render, staticRenderFns } from "./TrGameStatus.vue?vue&type=template&id=4b987ff6&scoped=true&"
import script from "./TrGameStatus.vue?vue&type=script&lang=js&"
export * from "./TrGameStatus.vue?vue&type=script&lang=js&"
import style0 from "./TrGameStatus.vue?vue&type=style&index=0&id=4b987ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b987ff6",
  null
  
)

export default component.exports